// extracted by mini-css-extract-plugin
export default {"debugPanel":"DebugPanel_debugPanel__S06fm","listItem":"DebugPanel_listItem__X0WoR"};